<template>
    <button
        ref="toggle"
        :class="['user-dropdown', `user-dropdown-${variant}`]"
        data-cy="userDropdown"
    >
        <span
            class="user-dropdown-name"
            data-cy="userDropdownName"
        >
            <!-- Default content to be displayed in the dropdown toggle -->
            <slot />
        </span>

        <FontAwesomeIcon
            class="icon"
            :icon="['far', 'user']"
        />

        <b-popover
            boundary="window"
            :custom-class="`user-dropdown-popover user-dropdown-popover-${variant}`"
            placement="bottomright"
            :target="() => $refs.toggle"
            triggers="click blur"
        >
            <ul>
                <li>
                    <div
                        v-if="$slots['user-dropdown-header']"
                        class="user-dropdown-header"
                    >
                        <!-- Displays a header at the top of the dropdown, if content is provided -->
                        <slot name="user-dropdown-header" />
                    </div>
                </li>

                <!-- Displays given dropdown items -->
                <slot name="user-dropdown-items" />

                <UserDropdownItem
                    v-if="variant !== 'policy-system'"
                    @click.native="changePassword"
                >
                    <FontAwesomeIcon
                        class="icon"
                        :icon="['far', 'key']"
                    />

                    Change Password
                </UserDropdownItem>

                <UserDropdownItem
                    v-if="variant === 'default'"
                    @click.native="logout"
                >
                    <FontAwesomeIcon
                        class="icon"
                        :icon="['far', 'sign-out-alt']"
                    />

                    Logout
                </UserDropdownItem>
            </ul>
        </b-popover>
    </button>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faBars, faKey, faSignOutAlt, faUser} from '@fortawesome/pro-regular-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    import UserDropdownItem from './UserDropdownItem.vue';

    library.add(faBars, faKey, faSignOutAlt, faUser);

    /**
     * @group Layout
     * A component to display a User Dropdown; to be used in the
     * `user-dropdown` slot of the `Header` component.
     */
    export default {
        name: 'UserDropdown',
        components: {
            FontAwesomeIcon,
            UserDropdownItem,
        },
        provide() {
            return {variant: this.variant};
        },
        props: {
            /**
             * Sets the variant/type of user dropdown; provided to children
             */
            variant: {
                // `default` / `policy-system`
                type: String,
                // `default`
                default: 'default',
                validator: (value) => {
                    return ['default', 'policy-system'].includes(value);
                },
            },
        },
        methods: {
            logout() {
                /**
                 * Emitted when the logout item is clicked. Functionality for logging
                 * out should be handled in the parent.
                 */
                this.$emit('logout');
            },
            changePassword() {
                /**
                 * Navigation to Users change-password route is handled by the component
                 * and does not need to be handled by the parent usage.
                 */
                window.location = `${process.env.VUE_APP_ADMIN_URL_USERS}/change-password`;
            },
        },
    };
</script>
